<template>
  <div class="modal-window">
    <header class="modal-header">
      <div class="tit">
        {{ modalInfo.groupKbn == "SHAR" ? $i18nUtil.trans("message.SharAndCfrcSetting.001","정보공유 관리") : $i18nUtil.trans("message.SharAndCfrcSetting.002","회의협의체 관리") }}
      </div>
      <button @click="$emit('close')" class="btn_close">{{$i18nUtil.trans("button.close","닫기")}}</button>
    </header>

    <div class="modal-content">
      <div class="tab_ty1" id="tabsTy1">
        <ul class="tab-menu">
          <li
            v-for="(tab, index) in tabsTy1"
            v-bind:class="{ active: currentTab1 === index }"
          >
            <button type="button" v-on:click="tabsClick(index)">
              {{ tab }}
            </button>
          </li>
        </ul>
        <div class="tab-content">
          <SharAndCfrcMemberManage
            v-if="currentTab1 == 0"
            v-bind:modalInfo="modalInfo"
            @closeModal="closeModal"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SharAndCfrcMemberManage from "./SharAndCfrcMemberManage";

import EventBus from "@/js/eventbus/eventBus";
export default {
  components: {
    SharAndCfrcMemberManage,
  },
  data() {
    return {
      currentTab1: 0,
      tabsTy1: [this.$i18nUtil.trans("message.SharAndCfrcSetting.003","관리자 관리")],
    };
  },
  props: {
    modalInfo: {
      type: Object,
      required: true,
    },
  },

  methods: {
    closeModal() {
      this.$emit("close");
    },
    tabsClick(index) {
      this.currentTab1 = index;
      // this.$refs.projectFolder.clearSearchFolder();
      // this.$refs.projectMember.searchReset();
      // this.$refs.projectInvitation.searchReset();
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/cowork/cosys/audit/base/tab/history/modal/SharAndCfrcSetting.vue